import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const CourtJudgement = ({ values }) => (
  <Content>
    {({
      initialQuestionsCourtJudgementLabel,
      initialQuestionsCourtJudgementYes = '',
      initialQuestionsCourtJudgementNo = '',
      courtActionText = ''
    }) => (
      <Field name="courtJudgement" subscription={{ touched: true, error: true }}>
        {({ input }) => (
          <GenericFieldWrapper
            inputId="courtJudgement"
            title={initialQuestionsCourtJudgementLabel}
            description={courtActionText}
          >
            <GenericRadio.InlineSet
              groupName="courtJudgement-group"
              items={[
                {
                  id: initialQuestionsCourtJudgementYes,
                  labelText: initialQuestionsCourtJudgementYes
                },
                {
                  id: initialQuestionsCourtJudgementNo,
                  labelText: initialQuestionsCourtJudgementNo
                }
              ]}
              {...input}
              selectedId={values.courtJudgement}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default CourtJudgement;
